import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Candidate from "../../layouts/Candidate";
import axios from "../../services/axios";
import swal from "sweetalert";
import $ from "jquery";
import { set } from "lodash";

function SubjectiveQuiz(props) {
  const { id } = useParams(); // candidateId

  //Initialized state
  const initialInputState = { answer: "" };
  const [formName, setFormName] = useState("");

  const [check, setCheck] = useState(false);

  useEffect(() => {
    {
      id &&
        axios.get(`/formtemplate`).then((res) => {
          const data = res.data;
          data.map((ele) => {
            if (ele._id === id) {
              setFormName(ele.name.split(" ").join("-"));
            }
          });
        });
    }
  }, [id]);

  // setState value
  const [eachValue, setValue] = useState(initialInputState);
  const [error, setError] = useState("");
  const [ids, setIds] = useState("");
  const [status, setStatus] = useState();
  // const formRef = useRef<HTMLFormElement>(null);
  const formRef = useRef(null);

  const [question, setQuestion] = useState("");
  const [keyWords, setKeywords] = useState("");
  const [load, setLoad] = useState(false);
  const [time, setTime] = useState(true);

  // Destructured state
  const { answer } = eachValue;

  //logic for maxcount
  let maxCount = 200;
  // let remainingCount =
  //   maxCount -
  //   eachValue.answer.trim().split(/[\w\d\’\'-.,<>/?|!@#*$%()+]+/gi).length;

  let remainingCount =
    maxCount -
    eachValue.answer.split(" ").filter(function (n) {
      return n != "";
    }).length;

  //Onchange event for input element
  const handleChange = (e) => {
    //var pattern = /[^a-zA-Z0-9., ]/g;
    //setStatus(true)
    if (remainingCount >= 1) {
      setValue({ ...eachValue, [e.target.name]: e.target.value });
      setError("");
    } else {
      setError("Words limit exceeded");
    }
  };

  // Submit event
  //     const handleSubmit = (e) => {
  //         e.preventDefault();
  //         setLoad(true)
  //         setTime(false)
  // //         swal({
  // //   title: "Good job!",
  // //   text: "You clicked the button!",
  // //   icon: "success",
  // //   button: "Aww yiss!",
  // // });
  //        alert("submitted successfully")
  //        axios.post("/questionBank/questionAnswer", {
  //             "questionId": questionId,
  //             "questionAnswer": answer,
  //             "keywords": keyword,
  //             "candidateId": ids,
  //       })
  //       .then((res) => {
  //         window.location.replace("/Application-submitted/" + formName);
  //         localStorage.removeItem("ids")
  //         // window.location.reload();
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });

  //         localStorage.removeItem("ques")
  //         localStorage.removeItem("keyword")
  //         localStorage.removeItem("questionId")
  //         localStorage.removeItem("minutes")
  //         localStorage.removeItem("seconds")
  //         setSecond(20)
  //         setMinute(0)
  //     }

  // practice submit

  async function handleSubmit(e) {
    e.preventDefault();
    setLoad(true);
    setTime(false);

    localStorage.removeItem("ques");
    localStorage.removeItem("keyword");
    localStorage.removeItem("questionId");
    localStorage.removeItem("minutess");
    localStorage.removeItem("secondss");
    setSecond(1);
    setMinute(0);

    try {
      const response = await axios.post("/questionBank/questionAnswer", {
        questionId: questionId,
        questionAnswer: answer !== "" ? answer : "null",
        keywords: keyword,
        candidateId: ids,
      });
    } catch (err) {
      // console.log(err);
    }
    window.location.replace("/Application-submitted/" + formName);
    localStorage.removeItem("ids");
  }

  // setTime interval
  const [second, setSecond] = useState(localStorage.getItem("secondss") || 0);
  const [minute, setMinute] = useState(localStorage.getItem("minutess") || 10);

  useEffect(() => {
    const timer = setInterval(() => {
      {
        time && setSecond(second - 1);
        localStorage.setItem("secondss", second);
        if (second === 0) {
          // formRef.current.dispatchEvent(new Event("submit", { cancelable: true }));
          setMinute(minute - 1);
          setSecond(60);
          if (minute === 0) {
            // formRef.current.submit();
            //formRef.current.dispatchEvent(new Event("submit"));
            formRef.current.dispatchEvent(
              new Event("submit", { cancelable: true })
            );
          }
        }
        localStorage.setItem("minutess", minute);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [second]);

  // SetTimeout
  const [que, setQue] = useState(localStorage.getItem("ques") || "");
  const [keyword, setKeyword] = useState(localStorage.getItem("keyword") || "");
  const [questionId, setQuestionId] = useState(
    localStorage.getItem("quesId") || ""
  );

  useEffect(() => {
    setQue(localStorage.getItem("ques"));
    setKeyword(localStorage.getItem("keyword"));
    setQuestionId(localStorage.getItem("quesId"));
  });

  useEffect(() => {
    // get question data
    {
      que === "" &&
        axios.get("/questionBank").then((res) => {
          const data = res.data;
          setQuestion(data.question);
          setKeywords(data.keywords);

          // store question and keywords in local storage
          localStorage.setItem("ques", data.question);
          localStorage.setItem("quesId", data._id);
          localStorage.setItem("keyword", data.keywords);
        });
    }

    setIds(localStorage.getItem("ids"));
  }, [second]);

  useEffect(() => {
    setTimeout(() => {
      setStatus(true);
    }, 2000);

    setTimeout(() => {
      setStatus(false);
    }, 8000);

    //localStorage.getItem("status")
    setCheck(localStorage.getItem("status"));
  }, []);

  useEffect(() => {
    {
      ids &&
        axios.get(`/candidates/${ids}`).then((res) => {
          const resp = res.data;
          if (resp.questionAnswerId && resp.questionAnswerId.avgScore) {
            setCheck(false);
          } else {
            setCheck(true);
          }
        });
    }
  }, [ids]);

  return (
    <Candidate>
      {check ? (
        <div className="row justify-content-center">
          <div className="col-md-8 mb-3">
            <h4 className="text-center mb-0 fw-bold-cce">Assessment Test</h4>
            <p className="text-center mainHeadingCaption mt-2">
              Maxicus empowers YOU - our employees—to grow beyond your
              potential. We offer the perfect opportunities for your personal,
              professional, and financial success.
            </p>

            <div className="mb-3 mt-5 pl-4">
              <h5 className="m-0">
              {que}
              </h5>
              {/* <h5 className="mb-1 questionQuiz">{que}</h5> */}
              <p className="mainHeadingCaption">
                Include the keywords: {keyword?.split(" ").join(", ")}
              </p>
            </div>

            <div className="p-3 bg-white rounded">
              <div className="row align-items-center">
                <div className="col-md-5">
                  <h5 className="">Start here</h5>
                  {/* <div className="qzDevider"></div> */}
                </div>
                <div className="col d-flex  justify-content-end">
                  {" "}
                  {/* <div className=""> */}
                  <span className="mr-1">
                    {minute}:{second < 10 ? `0${second}` : second}
                  </span>
                  <span className="mr-3">Timer </span> {/* </div> */}
                  {/* <div className="ml-3"> */}
                  <span className="mr-1">{remainingCount}</span>{" "}
                  <span>Words </span>
                  {/* </div> */}
                </div>
              </div>
              {/* <h1 className="mt-5" >Sujective Quiz</h1> */}
              <div className="form-group mt-3">
                <form onSubmit={handleSubmit} ref={formRef}>
                  {/* <label>Questions</label> */}
                  <textarea
                    className="form-control"
                    style={{ height: "200px" }}
                    placeholder="Enter answer....."
                    name="answer"
                    type="textfield"
                    onpaste="return false"
                    value={answer}
                    onChange={handleChange}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    onCopy={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  ></textarea>
                  {error !== "" && (
                    <span style={{ color: "red" }}>{error}</span>
                  )}
                  <button
                    disabled={load}
                    className="btn btn-primary border-0 mt-3"
                    type="submit"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
          {status && (
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#f57921b5",
                position: "absolute",
                height: "75px",
                right: "8px",
                color: "white",
              }}
            >
              <div className="card-body py-2">
                <p className="card-text">
                  Please, don't refresh page before submission
                </p>{" "}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="row justify-content-center mt-5">
          <h1>Access denied</h1>
        </div>
      )}

      {/* <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
  Launch demo modal 
</button> */}

      {/* <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div> */}
    </Candidate>
  );
}

export default SubjectiveQuiz;
